var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.934,
    height: 33.239,
    viewBox: "0 0 35.934 33.239",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f4748f;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-354.027 -191)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.026,6a3.165,3.165,0,0,0-3.144,3.144V11.39H7.144A3.165,3.165,0,0,0,4,14.534v21.56a3.165,3.165,0,0,0,3.144,3.144H36.789a3.165,3.165,0,0,0,3.144-3.144V14.534a3.165,3.165,0,0,0-3.144-3.144H30.052V9.144A3.165,3.165,0,0,0,26.908,6Zm0,2.7h9.882a.429.429,0,0,1,.449.449V11.39H16.577V9.144A.429.429,0,0,1,17.026,8.7ZM7.144,19.625H36.789a.429.429,0,0,1,.449.449v6.588H24.662v-.449a1.348,1.348,0,0,0-1.348-1.348h-2.7a1.348,1.348,0,0,0-1.348,1.348v.449H6.7V20.074A.429.429,0,0,1,7.144,19.625ZM6.7,29.357H19.272v.449a1.348,1.348,0,0,0,1.348,1.348h2.7a1.348,1.348,0,0,0,1.348-1.348v-.449H37.239v6.738a.429.429,0,0,1-.449.449H7.144a.429.429,0,0,1-.449-.449Z",
    transform: "translate(350.027 185)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 30.469,
    height: 8.31,
    transform: "translate(356.759 209.004)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(366.32 207.487)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M29.334,22.685H26.379V26.88h-4.2v2.954h4.2v4.194h2.955V29.834h4.194V26.88H29.334Z",
    transform: "translate(-22.18 -22.685)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.5973fe3c5d9b8ef76883828d80c0b7c8.svg";
export { ForwardRef as ReactComponent };